import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import OmniAvatar from "../ui/omniAvatar";

const WidgetAvatar = props => {
  const theme = useTheme();

  return (
    <Box>
      <OmniAvatar
        sx={{
          // marginTop: "-8px",
          // width: "48px",
          // height: "48px",

          boxShadow: theme.shadows[3],
        }}
        {...props}
      />
    </Box>
  );
};

export default WidgetAvatar;
